import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import { AbilityService } from '../_shared/services/ability.service';
import { SessionService } from '../_shared/services/session.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  constructor(
    public router: Router,
    private sessionService: SessionService,
    private abilityService: AbilityService
  ) {}

  canLoad(route: ActivatedRouteSnapshot): boolean {
    // console.log('canLoad');
    // console.log(route);
    // return true;

    return this.checkLogin(route);
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    return this.checkLogin(route);
  }

  private checkLogin(route): boolean {
    if (this.sessionService.isLoggedIn()) {
      if (route.data && route.data.permission && !this.abilityService.can(route.data.permission)) {
        this.router.navigate(['/ng']);

        return false;
      }

      return true;
    }

    this.router.navigate(['/ng/login']);

    return false;
  }
}

// if (!this.sessionService.isLoggedIn()) {
//   this.router.navigate(['/ng/login']);
//   // this.router.navigate(['/', 'ng/login']);

//   return false;
// }

// // const permission = route.data['permission'];
// if (route.data['permission'] && !this.abilityService.can(route.data['permission'])) {
//   this.router.navigate(['/ng']);

//   return false;
// }

// return true;

// , state: RouterStateSnapshot

// UrlTree,
// import { Observable } from 'rxjs';

// | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | UrlTree
